module.exports = __webpack_public_path__ + "img/spilka250x82.6965d16b.png";